import BonusComplianceServices from "../../services/BonusComplianceServices";
const state = {
    loadingBonusCompliance: false,
    bonusCompliancePending: [],
    bonusCompliancePendingPdf: [],
    bonusCompliancePendingExcel: [],
    bonusComplianceLiquidation: [],
    bonusCompliancePermissionApproveAndBill: false,
    bonusComplianceSelected: [],
    bonusCompliancePreliquidationPending: [],
    bonusCompliancePdf: [],
    bonusComplianceExcel: [],
    bonusCompilanceLiquidationDetail: [],
    isBroker: false,
};
import { globalData } from "@/main";
const getters = {
    loadingBonusCompliance: state => {
        return state.loadingBonusCompliance;
    },
    bonusCompliancePending: state => {
        return state.bonusCompliancePending;
    },
    bonusCompliancePendingPdf: state => {
        return state.bonusCompliancePendingPdf;
    },
    bonusCompliancePendingExcel: state => {
        return state.bonusCompliancePendingExcel;
    },
    bonusComplianceLiquidation: state => {
        return state.bonusComplianceLiquidation;
    },
    bonusCompliancePermissionApproveAndBill: state => {
        return state.bonusCompliancePermissionApproveAndBill;
    },
    bonusComplianceSelected: state => {
        return state.bonusComplianceSelected;
    },
    bonusCompliancePreliquidationPending: state => {
        return state.bonusCompliancePreliquidationPending;
    },
    bonusCompliancePdf: state => {
        return state.bonusCompliancePdf;
    },
    bonusComplianceExcel: state => {
        return state.bonusComplianceExcel;
    },
    bonusCompilanceLiquidationDetail: state => {
        return state.bonusCompilanceLiquidationDetail;
    },
    isBrokerBonusCompliance: state => {
        return state.isBroker;
    },
};
const actions = {
    updateBonusComplianceSelected(context, payload) {
        state.bonusComplianceSelected = payload;
    },
    getBonusComplianceLiquidationDetail(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        return BonusComplianceServices.bonusDetailLiquidation(payload)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusCompilanceLiquidationDetail = [];
                    if (!globalData.validaSucursal) {
                        state.bonusCompilanceLiquidationDetail = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].vtAgency.toUpperCase() == localStorage.getItem("agencyName").toUpperCase()) {
                            state.bonusCompilanceLiquidationDetail.push(res.data.data[i]);
                        }
                    }
                    }
                    
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }

            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusComplianceLiquidation(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusComplianceServices.liquidation(payload, apsId)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusComplianceLiquidation = [];
                     if (!globalData.validaSucursal) {
                        state.bonusComplianceLiquidation = res.data.data
                    } else { for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].vtAgency.toUpperCase() == agencyName.toUpperCase()) {
                            state.bonusComplianceLiquidation.push(res.data.data[i]);
                        }
                    }}
                    
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePending(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusComplianceServices.pending(payload, apsId)
            .then(res => {
                state.bonusCompliancePending = [];
                if (res.data.error == 0) {
                    if (!globalData.validaSucursal) {
                        state.bonusCompliancePending = res.data.data
                    } else {

                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].agencyName.toUpperCase() == agencyName.toUpperCase()) {
                                state.bonusCompliancePending.push(res.data.data[i]);
                            }
                        }
                    }

                } else {
                    if (res.data.error != 100) {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePendingPdf(context) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusComplianceServices.pendingPdf(apsUserName, apsId, agency)
            .then(res => {
                state.bonusCompliancePendingPdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePendingExcel(context) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsUserName = context.rootGetters.userProfile.user_name;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusComplianceServices.pendingExcel(apsUserName, apsId, agency)
            .then(res => {
                state.bonusCompliancePendingExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePreliquidationPending(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusComplianceServices.preliquidation(payload, apsId, agency)
            .then(res => {
                if (res.data.error == 0) {
                    state.bonusCompliancePreliquidationPending = [];
                    if (!globalData.validaSucursal) {
                        state.bonusCompliancePreliquidationPending = res.data.data
                    } else {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].vtAgency.toUpperCase() == agencyName.toUpperCase()) {
                                state.bonusCompliancePreliquidationPending.push(res.data.data[i]);
                            }
                        }

                    }

                } else {
                    //Erro 100 no viene informacion
                    if (res.data.error == 100) {
                        state.bonusCompliancePreliquidationPending = [];
                    } else {
                        context.commit("updateNotificationError", res.data.msg);
                    }

                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    bonusCompliancePreliquidationValidatePermission(context) {
        const apsRuc = context.rootGetters.userProfile.identity;
        return BonusComplianceServices.validatePermission(apsRuc)
            .then((res) => {
                if (res.data.error == 0) {
                    state.bonusCompliancePermissionApproveAndBill = true;
                } else {
                    state.bonusCompliancePermissionApproveAndBill = false;
                }
            })
            .catch(() => {
                state.permissionApproveAndBill = false;
            })
    },
    sendBonusCompliancePreliquidationGeneration(context) {
        context.commit("showLoadingBonusComplianceIndicator");
        const apsRuc = context.rootGetters.userProfile.identity;
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        let agency = "";
        if (!globalData.validaSucursal) {
            agency = "Todas";

        } else {
            agency = agencyName;
        }
        return BonusComplianceServices.preliquidationGeneration(null, apsRuc, apsId, agency)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    sendBonusCompliancePreliquidationApprove(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusComplianceServices.preliquidationApprove(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    sendBonusCompliancePreliquidationApproveAndBill(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusComplianceServices.preliquidationApproveAndBill(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    sendBonusCompliancePreliquidationReject(context, complianceBonus) {
        let data = [complianceBonus];
        const apsId = context.rootGetters.userProfile.id_aps_vt;
        const agencyName = context.rootGetters.agencyName;
        return BonusComplianceServices.preliquidationReject(data, apsId, agencyName)
            .then(res => {
                if (res.data.error == 0) {
                    context.commit("updateNotificationInfo", res.data.msg);
                    return true;
                } else if (res.data.error == 105) {
                    context.commit("updateNotificationWarning", res.data.msg);
                    return false;
                } else {
                    context.commit("updateNotificationError", res.data.msg);
                    return false;
                }
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePdf(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        return BonusComplianceServices.bonusCompliancePdf(payload)
            .then(res => {
                state.bonusCompliancePdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusCompliancePreliminarPdf(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        return BonusComplianceServices.bonusCompliancePreliminarPdf(payload)
            .then(res => {
                state.bonusCompliancePdf = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    getBonusComplianceExcel(context, payload) {
        context.commit("showLoadingBonusComplianceIndicator");
        return BonusComplianceServices.bonusComplianceExcel(payload)
            .then(res => {
                state.bonusComplianceExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingBonusComplianceIndicator");
            });
    },
    validateIsUserAgentBonusCompliance(context, userId) {
        return BonusComplianceServices.IsUserAgent(userId)
            .then((respuesta) => {
                console.log(respuesta.data);
                context.commit("loadingAsBrokerBonusCompliance", { isBroker: respuesta.data != null });
                state.isBroker = respuesta.data != null;
            })
            .catch(() => {
            })
            .finally(() => {
            });
    },
};
const mutations = {
    showLoadingBonusComplianceIndicator(state) {
        state.loadingBonusCompliance = true;
    },
    hideLoadingBonusComplianceIndicator(state) {
        state.loadingBonusCompliance = false;
    },
    loadingAsBrokerBonusCompliance(state, { isBroker }) {
        state.isBroker = isBroker;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};